export const ApiUrl = {
  PROD: "https://api.carbonhealth.com",
  STAGING: "https://api.staging.carbonhealth.com",
  LOCAL: "http://localhost:9000",
  PROD_GRAPHQL: "https://graphql.api.carbonhealth.com/graphql",
  STAGING_GRAPHQL: "https://graphql.api.staging.carbonhealth.com/graphql",
  LOCAL_GRAPHQL: "http://localhost:4000/graphql",
} as const;
